import React from 'react';
import { getIcon } from '../../utils/iconUtils';
import { mockApps } from '../../utils/mockData';
import { PlusIcon, XIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface AppTileViewProps {
  onOpenApp: (appId: string) => void;
  createAppTile?: any;
  isCustomizing?: boolean;
  onDelete?: (appId: string) => void;
}
export const AppTileView = ({
  onOpenApp,
  createAppTile,
  isCustomizing,
  onDelete
}: AppTileViewProps) => {
  const navigate = useNavigate();
  return <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-4" data-id="element-286">
      {createAppTile && <button className="flex flex-col items-center p-4 rounded-lg hover:bg-gray-50 transition-colors" onClick={createAppTile.onClick} data-id="element-287">
          <div className={`${createAppTile.iconBg} w-16 h-16 rounded-xl flex items-center justify-center mb-2`} data-id="element-288">
            <PlusIcon className="h-6 w-6 text-white" data-id="element-289" />
          </div>
          <span className="text-sm font-medium text-center" data-id="element-290">
            {createAppTile.title}
          </span>
        </button>}
      {mockApps.map(app => <button key={app.id} className="flex flex-col items-center p-4 rounded-lg hover:bg-gray-50 transition-colors relative" onClick={() => navigate(`/app-interface/${app.id}`)} data-id="element-291">
          {isCustomizing && <button onClick={e => {
        e.stopPropagation();
        onDelete?.(app.id);
      }} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 shadow-md hover:bg-red-600 transition-colors" data-id="element-292">
              <XIcon className="h-4 w-4" data-id="element-293" />
            </button>}
          <div className={`${app.iconBg} w-16 h-16 rounded-xl flex items-center justify-center mb-2`} data-id="element-294">
            {getIcon(app.icon)}
          </div>
          <span className="text-sm font-medium text-center" data-id="element-295">{app.title}</span>
        </button>)}
    </div>;
};